<template>
	<page>
		<title-view>
			סוגי משחק
			<v-btn
				slot="actions"
				color="primary"
				btn
				@click="onEdit({})"
			>
				הוסף סוג משחק
			</v-btn>
		</title-view>
		<row>
			<c-col>
				<types-table @edit="onEdit" />
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">טופס סוגי משחק</span>
			<type-form
				v-if="openModal"
				@save="openModal = false"
			/>
		</popup-dialog>
	</page>
</template>

<script>
import TypeForm from "src/view/types/TypeForm";
import TypesTable from "src/view/types/TypesTable";
import { types } from "dev/store/modules/Type.module";

export default {
	name: "TypesView",
	components: { TypesTable, TypeForm },
	data () {
		return {
			openModal: false,
		};
	},
	methods: {
		onEdit (type) {
			if (type.id) {
				const organizations = type.organizations.map((org) => org.id);
				const newType = Object.assign({}, type, { organizations });
				console.log(newType);
				this.$store.commit(types.GET, newType);
			} else {
				this.$store.commit(types.CREATE, type);
			}
			this.openModal = true;
		},
	},
};
</script>

<style scoped>
</style>
